import { render, staticRenderFns } from "./MiniprogramPunchEditor.vue?vue&type=template&id=5a9267b6&scoped=true&"
import script from "./MiniprogramPunchEditor.vue?vue&type=script&lang=js&"
export * from "./MiniprogramPunchEditor.vue?vue&type=script&lang=js&"
import style0 from "./MiniprogramPunchEditor.vue?vue&type=style&index=0&id=5a9267b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9267b6",
  null
  
)

export default component.exports